import { NonIdealState } from '@blueprintjs/core';
import * as React from 'react';
import { MosaicKey } from 'react-mosaic-component/lib/types';

import { MappingType } from 'src/containers/ProjectDiagram/types/data';
import { getMappingType } from 'src/containers/ProjectDiagram/utils/mapping/getMappingType';
import { useMappingFromRoute } from 'src/containers/ProjectMapping/hooks/useMappingFromRoute';
import { ProjectClassMapping } from 'src/containers/ProjectMapping/ProjectClassMapping';
import { VoiceboxFooter } from 'src/containers/Voicebox/VoiceboxFooter';
import { projectMappingsSelector } from 'src/selectors/projectMappings';
import * as copy from 'src/templates/copy';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';
import { useRouterParams } from 'src/utils/hooks/useRouterParams';

type ProjectMappingViewProps = { id: MosaicKey };

export const ProjectMappingView: React.VFC<ProjectMappingViewProps> = () => {
  const mapping = useMappingFromRoute();
  const mappingType = getMappingType(mapping);

  const { projectId } = useRouterParams();
  const allMappings = useReduxSelector(projectMappingsSelector(projectId));

  let body: JSX.Element | null = null;
  if (mappingType === MappingType.CLASS) {
    body = <ProjectClassMapping key={mapping?.key} />;
  }
  if (mappingType === MappingType.NONE) {
    body = (
      <NonIdealState
        description={
          allMappings.length > 0
            ? copy.components.projectMapping.emptyState.description
            : ''
        }
        title={copy.components.projectMapping.emptyState.title}
      />
    );
  }

  return (
    <div className="sd-project-mapping-view">
      {body}
      <VoiceboxFooter />
    </div>
  );
};
